import React, { useCallback } from 'react'
import { uniqueId } from 'lodash'
import ReactDOM from 'react-dom'

// eslint-disable-next-line no-unused-vars
import { ILoading, IUseLoading } from '../interfaces/loading'

import { Loading } from '../components/Loading'

export const useLoading = (props: IUseLoading) => {
  const render = useCallback((element: JSX.Element, id: string) => {
    try {
      ReactDOM.render(
        element,
        document.querySelector(`.loading-container[data-id=${id}]`)
      )
    } catch (error) {
      console.error('Render loadind fail!')
    }
  }, [])

  const create = useCallback((loading: ILoading) => {
    const id = uniqueId('loading_')
    const node = document.createElement('div')
    node.setAttribute('class', 'loading-container')
    node.setAttribute('data-id', id)
    document.querySelector('#root-loading')!.prepend(node)

    render(<Loading {...loading} />, id)

    return id
  }, [])

  const close = useCallback((id: string) => {
    const loadingContainer = document.querySelector(
      `.loading-container[data-id=${id}]`
    )!

    document.querySelector('#root-loading')!.removeChild(loadingContainer)

    return id
  }, [])

  const loading = useCallback(
    (id?: string) => {
      if (id) {
        const timeout = props?.timeout || 0

        setTimeout(() => {
          close(id)
        }, timeout)

        return id
      }

      return create(props)
    },
    [create]
  )

  return { loading }
}
